module.exports = __webpack_public_path__ + "img/block-7.82e9c3b5.svg";